import { useNavigate } from "react-router-dom";
import axios from "../api/axios";
import { useAuth } from "./useAuth";

const useLogout = () => {
  let navigate = useNavigate();
  const { setAuth, setPersist } = useAuth();

  const logout = async () => {
    try {
      let url = `auth/logout`;
      let options = {
        method: "POST",
        url,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      };
      const response = await axios(options);
      if (response.data.status === 1) {
        setAuth({});
        setPersist(false);
        localStorage.removeItem("tk");
        localStorage.removeItem("rtkn");
        localStorage.removeItem("persist");
        localStorage.removeItem("remember_me");
        document.cookie = `remember_me=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        navigate(`/`, { replace: true });
      }
    } catch (err) {
      // console.error(err);
    }
  };

  return logout;
};

export default useLogout;
